(() => {
  const LABEL_SELECTOR = '.loox-rating-label';
  const RATING_SELECTOR = '.loox-rating[data-rating-label]';
  const APPLIED_ATTR = 'data-label-applied';

  function applyLabel(ratingEl) {
    const label = ratingEl.querySelector(LABEL_SELECTOR);
    if (!label || label.hasAttribute(APPLIED_ATTR)) return;

    label.textContent = ratingEl.dataset.ratingLabel;
    label.setAttribute(APPLIED_ATTR, '');
  }

  function applyAll() {
    document.querySelectorAll(RATING_SELECTOR).forEach(applyLabel);
  }

  // Apply to any labels already rendered by Loox
  applyAll();

  // Watch for Loox injecting labels asynchronously
  const observer = new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        if (node.matches(LABEL_SELECTOR)) {
          const ratingEl = node.closest(RATING_SELECTOR);
          if (ratingEl) applyLabel(ratingEl);
        }

        node.querySelectorAll(LABEL_SELECTOR).forEach((label) => {
          const ratingEl = label.closest(RATING_SELECTOR);
          if (ratingEl) applyLabel(ratingEl);
        });
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
